import { useCallback, useEffect, useState } from "react";

import { IDependent } from "library/types";
import styled from "styled-components";

import { ProfileContentWrap } from "components/styled";
import useEmployee from "hooks/useEmployee";

import { DependentForm } from "./DependentForm";
import { DependentProfile } from "./DependentProfile";
import { EmployeeDependentsHeaderButton } from "./EmployeeDependentsHeaderButton";

export function EmployeeDependents() {
  const { employeeData } = useEmployee();

  const [addNewDependent, setAddNewDependent] = useState(false);
  const [selectedDependent, setSelectedDependent] = useState<IDependent | null>(null);

  const dependentList = employeeData?.dependents;

  const handleCloseAddNewDep = useCallback(() => {
    setAddNewDependent(false);
  }, []);

  const handleAddNewDep = useCallback(() => {
    setAddNewDependent(true);
  }, []);

  const removeSelectedDependent = useCallback(() => {
    setSelectedDependent(null);
  }, []);

  const handleSelectedDependent = useCallback((dependent) => {
    setSelectedDependent(dependent);
  }, []);

  useEffect(() => {
    const updatedSelectedDependent = employeeData?.dependents?.find(
      (dependent) => dependent?.employeeDependentTag === selectedDependent?.employeeDependentTag
    );
    if (updatedSelectedDependent) {
      setSelectedDependent(updatedSelectedDependent);
    }
  }, [employeeData]);

  return (
    <ProfileContentWrap>
      <EmployeeDependentsHeaderButton
        addNewDependent={addNewDependent}
        selectedDependent={!!selectedDependent}
        setCloseAddNewDep={handleCloseAddNewDep}
        setAddNewDependent={handleAddNewDep}
        removeSelectedDependent={removeSelectedDependent}
      />
      {addNewDependent ? (
        <DependentForm
          addNew
          editMode={!!addNewDependent}
          setEditMode={() => {
            setSelectedDependent(null);
          }}
          employeeData={employeeData}
          removeNewDependent={handleCloseAddNewDep}
        />
      ) : null}
      <>
        {selectedDependent ? (
          <>
            <DependentProfile
              fullView
              setEditDependent={handleSelectedDependent}
              dependentData={selectedDependent}
            />
            <DependentForm
              dependentData={selectedDependent}
              employeeData={employeeData}
              editMode={!!selectedDependent}
              setEditMode={() => {
                setSelectedDependent(null);
              }}
            />
          </>
        ) : addNewDependent ? null : (
          <ListWrap>
            {dependentList?.map((dependent: IDependent) => (
              <DependentProfile
                setEditDependent={setSelectedDependent}
                key={dependent?.employeeDependentTag}
                dependentData={dependent}
              />
            ))}
          </ListWrap>
        )}
      </>
    </ProfileContentWrap>
  );
}

const ListWrap = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
